<script setup lang="ts">

import { ref, reactive, computed, onMounted } from "vue";
import { useViewModelInstance } from "@app/Carbucks";
import { comma } from "@library/Utilities";

import type { ICarbucksProfile } from "@domain/Carbucks";
import type { IMyGarageViewModel } from "@app/MyGarage";

import Loading from "@app/Components/Layout/Loading/Loading.vue";

const carbucks = ref<ICarbucksProfile>();  
const model= defineModel<IMyGarageViewModel>( { required: true } );

onMounted( async () => {
    const viewModel = await useViewModelInstance();
    carbucks.value = reactive( viewModel.profile );  
})

</script>

<template>

    <div>
        <RouterLink
            to="/carbucks"
            class="border rounded-lg 2xl:rounded-xl flex h-full items-center
                border-white/5 bg-white/5 hover:!bg-white-[12%] text-white/60"
            :class="model.carePlan.carbucksProtect.isEnabled ? 'p-4 2xl:p-6 py-2' : 'px-4 2xl:px-6'">

            <transition mode="out-in"
                enter-active-class="transition ease-out duration-500"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-150"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95">

                <template v-if="carbucks == null">
                    <Loading />
                </template>

                <template v-else>
                    <div class="flex w-full">
                        <div class="flex-1">
                            <!-- <img 
                                src="@/assets/images/carbucks-dark-mode.png"  
                                class="h-10 3xl:h-12 -left-1 drop-shadow-sm brightness-110" 
                            /> -->
                            <h2 class="text-3xl 2xl:text-4xl font-extrabold flex items-end
                                    text-primary-500 dark:text-white">
                                ${{ comma( carbucks.availableAmount, 2 ) }}
                            </h2>
                            <div class="text-white/40 text-xs 2xl:text-base font-normal uppercase mt-0.5">
                                Cashback
                            </div>
                        </div>
                        <div class="flex items-center gap-1">
                            <Icon name="chevron-right" />
                        </div>
                    </div>
                </template>

            </transition>  
             
        </RouterLink>
    </div>


</template>